var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHollowStar = function SvgHollowStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M14.926 1.56c.926-1.589 3.222-1.589 4.148 0l3.86 6.627a2.4 2.4 0 0 0 1.565 1.138l7.495 1.623c1.798.389 2.507 2.573 1.282 3.944l-5.11 5.718a2.4 2.4 0 0 0-.598 1.841l.773 7.63c.185 1.83-1.673 3.18-3.356 2.438l-7.017-3.092a2.4 2.4 0 0 0-1.936 0l-7.017 3.092c-1.683.742-3.54-.608-3.356-2.438l.773-7.63a2.4 2.4 0 0 0-.598-1.84l-5.11-5.719C-.5 13.521.208 11.337 2.006 10.948l7.495-1.623a2.4 2.4 0 0 0 1.566-1.138z"
  })));
};
export default SvgHollowStar;